import { render } from "./UserAccount.vue?vue&type=template&id=491530c4"
import script from "./UserAccount.vue?vue&type=script&lang=js"
export * from "./UserAccount.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/userAccounts/UserAccount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "491530c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('491530c4', __exports__)) {
    console.log('reload')
    api.reload('491530c4', __exports__)
  }
  
  module.hot.accept("./UserAccount.vue?vue&type=template&id=491530c4", () => {
    console.log('re-render')
    api.rerender('491530c4', render)
  })

}


export default __exports__